import { Divider } from './components/Divider';
import { Paper } from './components/Paper';

import type { PaperProps } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

type DisclaimerProps = PaperProps & PropsWithChildren;

export const Disclaimer: FC<DisclaimerProps> = ({ children, ...props }) => (
  <Paper elevation={8} {...props}>
    <Divider />
    {children}
  </Paper>
);
